export default "__VITE_ASSET__6a74afa3__"